import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ISavedChartPanel, SavedChartPanel } from "../chart/savedChartPanel";
import { IPagePanel } from "../common/pagePanel";
import { Base } from "ui/Scripts/source/framework/base";

export interface ISharedPanel extends ISavedChartPanel {
    shareUser: IModifyUser;
    userGroups: IModifyUser[];
}

export class SharedPanel extends SavedChartPanel implements ISharedPanel {
    shareUser: ModifyUser;
    userGroups: ModifyUser[];

    constructor();
    constructor(obj: ISharedPanel);
    constructor(obj: IPagePanel);
    constructor(obj?: any) {
        super(obj);
        this.shareUser = new ModifyUser(obj?.shareUser);
        this.userGroups = Base.getTypedArray(obj?.userGroups, ModifyUser);
    }
}

export interface ISharedPanelSave extends ISavedChartPanel {
    sharedByUserCode: string;
    userGroupCodes: string[];
}

export class SharedPanelSave extends SavedChartPanel implements ISharedPanelSave {
    sharedByUserCode: string;
    userGroupCodes: string[];

    constructor();
    constructor(obj: ISharedPanel);
    constructor(obj?: any) {
        super(obj);
        this.sharedByUserCode = obj?.shareUser?.code || "";
        this.userGroupCodes = obj?.userGroups?.map(i => i.code) || [];
    }
}